export default __webpack_public_path__ + "static/Rocket_Turret-463bf9684d7d5831def4b0ba291c2bb9.png";